import { FlatList } from 'react-native';
import styled from 'styled-components/native';

import Button from '@src/components/Button';
import FontIcon from '@src/components/FontIcon';
import Separator from '@src/components/Separator';
import { Body1, H2 } from '@src/components/Typography';
import {
  idKeyExtractor,
  padding,
  primeBookNumColumns,
} from '@src/configuration/constants';
import { CollectionPreview, PrimeBook } from '@src/types';

export const List = styled(FlatList as new () => FlatList<PrimeBook>).attrs(
  () => ({
    removeClippedSubviews: true,
    initialNumToRender: 6,
    maxToRenderPerBatch: 6,
    scrollEventThrottle: 16,
    keyExtractor: idKeyExtractor,
    showsHorizontalScrollIndicator: false,
    ItemSeparatorComponent: Separator,
    contentContainerStyle: {
      paddingHorizontal: padding,
      paddingBottom: padding,
      paddingTop: padding,
    },
    columnWrapperStyle: {
      justifyContent: 'space-evenly',
    },
    numColumns: primeBookNumColumns,
  })
)``;

export const Collections = styled(
  FlatList as new () => FlatList<CollectionPreview>
).attrs(() => ({
  removeClippedSubviews: true,
  initialNumToRender: 15,
  maxToRenderPerBatch: 10,
  scrollEventThrottle: 16,
  keyExtractor: idKeyExtractor,
  contentContainerStyle: {
    paddingVertical: padding / 2,
  },
}))``;

export const CollectionLabel = styled(Body1)<{ active: boolean }>`
  padding: 15px 0px;
  color: ${({ active, theme }) =>
    active ? theme.colors.onPrimary : theme.colors.onBackground};
`;

export const CollectionItem = styled.TouchableOpacity<{ active: boolean }>`
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: ${({ active, theme }) =>
    active ? theme.colors.primary : theme.colors.background};
  border-radius: ${({ theme }) => theme.roundness}px;
  padding: 0px 7px;
`;

export const Bullet = styled(FontIcon).attrs<{ active: boolean }>(
  ({ active, theme }) => ({
    name: 'angle-right',
    size: 20,
    color: active ? theme.colors.onPrimary : theme.colors.text,
  })
)<{ active: boolean }>`
  padding: 0px 10px;
`;

export const Title = styled(H2)``;

export const SubmitButton = styled(Button).attrs(({ theme }) => ({
  mode: 'contained',
  uppercase: false,
  labelStyle: {
    color: theme.colors.onPrimary,
  },
}))`
  margin-top: 10px;
`;
